<template>
    <div class="content-conference" style="width: 100%; flex: 1; min-width: 0;">
        <!-- Aula não iniciada -->
        <div v-if="!video.settings.live" class="card px-3 py-4 w-100">
            <h1 class="my-auto mx-auto">
                {{ $t('lesson.conference.unavailable') }}
            </h1>
            <h3 class="mx-auto" v-if="video.settings.start_date">
                {{ $t('lesson.conference.start_at') }}: {{ $moment(video.settings.start_date).format('LLL') }}
            </h3>
        </div>

        <!-- Carregando URL -->
        <div v-else-if="loading" class="d-flex justify-center align-center" style="height: 500px">
            <div class="spinner-border text-primary" style="width: 64px; height: 64px;" role="status"></div>
        </div>

        <!-- Aguardando professor -->
        <div v-else-if="waitingTeacher" class="card px-3 py-4 w-100 text-center">
            <i class="mdi mdi-clock-outline" style="font-size: 64px; color: #fb6340;"></i>
            <h2 class="my-3">{{ $t('lesson.conference.waiting_teacher') }}</h2>
            <p>{{ $t('lesson.conference.teacher_not_started') }}</p>
            <button type="button" class="btn btn-primary" @click="loadUrl">
                <i class="mdi mdi-refresh mr-1"></i>
                {{ $t('common.try_again') }}
            </button>
        </div>

        <!-- Erro genérico -->
        <div v-else-if="error" class="card px-3 py-4 w-100 text-center">
            <i class="mdi mdi-alert-circle-outline" style="font-size: 64px; color: #f5365c;"></i>
            <h2 class="my-3">{{ $t('common.error') }}</h2>
            <button type="button" class="btn btn-primary" @click="loadUrl">{{ $t('common.try_again') }}</button>
        </div>

        <!-- Iframe Ágora -->
        <iframe
            v-else-if="iframeUrl"
            :src="iframeUrl"
            allow="camera; microphone; display-capture; autoplay; clipboard-write; fullscreen"
            style="width: 100%; height: calc(100vh - 150px); border: none;"
            :title="$t('lesson.conference.title')"
        />
    </div>
</template>

<script>
import { NCH_ENV } from '../../../../../js/nch-env';
export default {
    emits: ['input', 'update:modelValue'],
    name: 'ContentConference',

    props: {
        modelValue:     { type: Object },
        contentId: { type: Number, required: true },
    },

    data() {
        return {
            loading:        false,
            iframeUrl:      null,
            waitingTeacher: false,
            error:          false,
        }
    },

    computed: {
        video: {
            get()      { return this.modelValue },
            set(value) { this.$emit('update:modelValue', value) },
        },
    },

    watch: {
        'video.settings.live'(isLive) {
            if (isLive) this.loadUrl()
        },
    },

    methods: {
        async loadUrl() {
            this.loading        = true
            this.waitingTeacher = false
            this.error          = false
            this.iframeUrl      = null

            try {
                const response = await window.axios.get(
                    `/api/app/agora/join/${this.video.settings.id}`
                )
                this.iframeUrl = response.data.url
            } catch (err) {
                if (err.response?.status === 403) {
                    this.waitingTeacher = true
                } else {
                    this.error = true
                }
            } finally {
                this.loading = false
            }
        },

        subscribe() {
            window.Echo
                .private(`${NCH_ENV.APP_HOST}.Lesson.Conference.${this.video.settings.id}`)
                .listen('ConferenceLessonEvent', (e) => {
                    if (e.settings) {
                        this.video = {
                            ...this.video,
                            settings: { ...this.video.settings, ...e.settings, start_date: this.video.settings.start_date },
                        }
                    }
                })
        },
    },

    mounted() {
        this.subscribe()
        if (this.video.settings.live) this.loadUrl()
    },
}
</script>
